export default __webpack_public_path__ + "static/connectFeaturedImage-b03993d87b8817c8665c5524624ac985.png";